import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import logo from "../assets/OSM-logo.png";
export default function LandingPage() {

    const navigate = useNavigate();

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                navigate('/dashboard');
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-between">
            {/* Hero Section */}
            <header className="bg-white shadow">
                <div className="max-w-7xl mx-auto px-4 py-6 flex items-center justify-between">
                    <img src={logo} alt="OSM Planner Logo" className="h-9 z-10" />
                    <div className="space-x-4">
                        <Link
                            to="/login"
                            className="px-4 py-2 bg-gray-100 rounded-lg text-gray-700 hover:bg-gray-200"
                        >
                            Inloggen
                        </Link>
                        <Link
                            to="/register"
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        >
                            Registreren
                        </Link>
                    </div>
                </div>
            </header>

            {/* Main Section met video achtergrond */}
            <main className="relative flex-grow flex items-center justify-center text-center px-4 overflow-hidden">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover z-0"
                    src="https://www.osmakelaars.nl/wp-content/uploads/2025/04/OSM-Planner-header.mp4"
                />
                <div className="absolute inset-0 bg-white bg-opacity-80 z-10 flex items-center justify-center">
                    <div className="max-w-3xl">
                        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
                            Plan sneller. Verkoop slimmer. OSM Planner.
                        </h2>
                        <p className="text-lg text-gray-600 mb-8">
                            De slimme tool voor makelaars om bezichtigingen te organiseren, agenda’s te beheren
                            en klantcommunicatie te stroomlijnen – alles op één plek.
                        </p>
                        <div className="space-x-4">
                            <Link
                                to="/register"
                                className="inline-block px-6 py-3 bg-blue-600 text-white text-lg rounded-lg hover:bg-blue-700"
                            >
                                Start gratis
                            </Link>
                            <Link
                                to="/login"
                                className="inline-block px-6 py-3 bg-gray-200 text-gray-800 text-lg rounded-lg hover:bg-gray-300"
                            >
                                Ik heb al een account
                            </Link>
                        </div>
                    </div>
                </div>
            </main>





            <footer className="bg-white border-t py-4 text-center text-sm text-gray-500">
                &copy; {new Date().getFullYear()} OSM Planner. Alle rechten voorbehouden.
            </footer>
        </div>
    );
}